import { StoreMetadata } from "@commons-monorepo/index";
import {
  PAYMENT_GATEWAYS,
  PAYMENT_OPTIONS,
} from "../constants/payment-methods.constants";
import { PAYMENT_GATEWAY } from "../types/payment-methods.types";

export const getPaymentMethods = (
  storeMetadata: StoreMetadata,
): { name: string; logo?: string; option?: boolean }[] => {
  const methods: {
    [key: string]: { name: string; logo: string; option?: boolean };
  } = {};
  (storeMetadata.paymentMethods || []).map((paymentMethod) => {
    methods[String(paymentMethod.name).toLocaleLowerCase()] = {
      name: paymentMethod.name,
      logo: paymentMethod.logo,
    };
    if (PAYMENT_GATEWAYS[paymentMethod.provider as PAYMENT_GATEWAY]) {
      PAYMENT_GATEWAYS[paymentMethod.provider as PAYMENT_GATEWAY].forEach(
        (option) => {
          if (PAYMENT_OPTIONS[option]) {
            methods[String(option).toLocaleLowerCase()] = {
              name: PAYMENT_OPTIONS[option].id,
              logo: PAYMENT_OPTIONS[option].logo,
              option: true,
            };
          }
        },
      );
    }
  });

  return Object.keys(methods).map((method) => ({
    name: methods[method].name,
    logo: methods[method].logo,
    option: !!methods[method].option,
  }));
};
